import {
  ShippingLabelByPharmacist_shippingLabel,
  ShippingLabelByPharmacist_shippingLabel_receiver_address
} from '@/api/bff_types';

export const deliveryTypeMap = {
  '0': '새벽',
  '1': '당일'
} as const;

export type DeliveryTypeMap =
  typeof deliveryTypeMap[keyof typeof deliveryTypeMap];
export type DeliveryTypeMapKeys = keyof typeof deliveryTypeMap;

export type DeliveryAddress =
  ShippingLabelByPharmacist_shippingLabel_receiver_address;

type LabelPrintUserInfo = {
  name: string;
  phone: string;
  address: string;
};

export interface ShippingLabelByPharmacistService
  extends Omit<
    ShippingLabelByPharmacist_shippingLabel,
    'deliveryType' | 'sender' | 'receiver'
  > {
  deliveryType: DeliveryTypeMap;
  sender: LabelPrintUserInfo;
  receiver: LabelPrintUserInfo;
  areaCode: string;
}

export type Contact = {
  contactAlias: string;
  isActive: boolean;
  phone: string;
  isSaved?: boolean;
};

export type ContactService = Contact[];

export const contactAliasMap = ['대표번호', '추가번호 1', '추가번호 2'];

export const initialContacts = [...new Array(3)].map((_, i) => ({
  contactAlias: contactAliasMap[i],
  isActive: false,
  phone: '',
  isSaved: false
}));

export type IsAbsentService = {
  isAbsent: boolean;
};
